
import React from "react";

export const AILogo = () => {
  return (
    <div className="px-3 flex justify-center items-end">
      <img
        src="/lovable-uploads/0e47bf2b-66cf-483d-ae5d-59564078b1d0.png"
        alt="Arbeid & Inkludering logo"
        className="w-[90%] h-auto"
      />
    </div>
  );
};
